import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { replaceCommaIntoWhiteSpace } from '../CommonUtilities/commonUtilities';
 
const NumberFormatCustomSix = (props) => {
  const { inputRef, name, onChange, onBlur, ...other } = props;
 
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      onBlur={(e) => {
        onBlur({
          target: {
            name: name,
            value: replaceCommaIntoWhiteSpace(e.target?.value),
          },
        });
      }}
      decimalScale={6}
      fixedDecimalScale={false}
      thousandSeparator
      isNumericString
      allowNegative
    />
  );
};
 
export default NumberFormatCustomSix;
 
NumberFormatCustomSix.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
 